import { ReactNode } from 'react';
import { ThemeProvider } from '@/providers/theme-provider';
import { QueryClientProvider } from '@socialflows/shared-lib';
import { Toaster } from '@/components/ui/toaster';
import { AuthProvider } from '@/providers/auth-provider';

export function ClientProviders({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider>
      <QueryClientProvider>
        <AuthProvider>
          {children}
          <Toaster />
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
